






























































































































import { Component, Vue } from 'vue-property-decorator'
import { InitModule } from '@/store/modules/init'
import { list, Delete } from '@/api/menu'
import { Tree as ElTree } from 'element-ui'
import { ListItemProps, NodeProps } from './index.d'
import RootModal from './components/rootModal.vue'
import ChildModal from './components/childModal.vue'
import * as _ from 'lodash'

@Component({
  name: 'Menu',
  components: {
    RootModal,
    ChildModal
  }
})
export default class extends Vue {
  private appId = 0
  private visible = false
  private id: number | null = null
  private nodeId: number | null = null // 当前选中的节点id, 作为新增子菜单的父id
  private treeList: NodeProps[] = []
  private loading = false
  private tableData: NodeProps[] = []
  private defaultShowNodes: number[] = []
  private rootDialogFlag = false
  private childDialogFlag = false

  get appList() {
    return InitModule.appList
  }

  private async created() {
    await InitModule.GetAppList()
    if (this.appList.length > 0) this.appId = this.appList[0].id
    this.change()
  }

  // 初始化
  private async onLoad() {
    this.loading = true
    const { content } = await list<ListItemProps[]>({ appId: this.appId })
    this.treeList = this.handleNodeData(content)
    this.loading = false
    // 如果有选中节点则设置选中节点高亮状态
    this.$nextTick(() => {
      if (this.nodeId) {
        const tree = (this.$refs.tree as ElTree)
        // 设置选中节点
        tree.setCurrentKey(this.nodeId)
        // 设置子集展示
        this.tableData = tree.getNode(this.nodeId).data.children as NodeProps[]
      } else {
        this.tableData = []
      }
    })
  }

  // 选择平台
  private async change() {
    this.visible = false
    this.defaultShowNodes = []
    this.nodeId = null
    await this.onLoad()
    this.visible = true
  }

  // 处理树结构数据
  private handleNodeData(data: ListItemProps[]): NodeProps[] {
    return data.map(item => ({
      label: item.name,
      children: item.child.length > 0 ? this.handleNodeData(item.child) : [],
      ..._.omit(item, 'child')
    }))
  }

  // 树节点展开
  private handleNodeExpand(data: NodeProps) {
    // 保存当前展开的节点
    let flag = false
    this.defaultShowNodes.some(item => {
      if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
        flag = true
        return true
      }
    })
    if (!flag) { // 不存在则存到数组里
      this.defaultShowNodes.push(data.id)
    }
  }

  // 树节点关闭
  private handleNodeCollapse(data: NodeProps) {
    this.defaultShowNodes.some((item, i) => {
      if (item === data.id) {
        // 删除关闭节点
        this.defaultShowNodes.length = i
      }
    })
  }

  // 节点点击
  private async nodeClick(data: NodeProps, node: any) {
    node.expanded = true
    this.nodeId = data.id
    this.tableData = data.children
    this.handleNodeExpand(data)
  }

  // 删除菜单
  private async remove(id: number) {
    this.$confirm('是否删除该菜单？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      await Delete({ id })
      this.$message.success('删除成功')
      this.onLoad()
    })
  }

  private onDialogSubmit() {
    this.onLoad()
  }

  // 打开根菜单弹窗
  private openRootMOdal(id: number | null) {
    this.rootDialogFlag = true
    this.id = id
  }

  // 打开子菜单弹窗
  private openChildModal(id: number | null) {
    this.id = id
    const selectId = (this.$refs.tree as ElTree).getCurrentKey()
    if (!selectId) {
      this.$message.warning('请选择一个父菜单')
      return
    }
    this.childDialogFlag = true
  }
}
